export const formatNumber = (value: number, minimumFractionDigits: number = 2): string =>
  value.toLocaleString(navigator.language, { minimumFractionDigits });

export const convertToCurrency = (value: number): string => `£ ${formatNumber(value)}`;

/* Floating point stores 1.005 as 1.00499..., so a plain Math.round(x * 100)
   rounds a half penny down. The nudge is far below a penny. Matches the
   backend's helpers, so both sides round alike. */
const HALF_NUDGE = 1e-9;

/** Money to the penny, half up. Budgets are never rounded further. */
export const toPence = (value: number): number => {
  if (!Number.isFinite(value)) return 0;
  return (Math.sign(value) * Math.round(Math.abs(value) * 100 + HALF_NUDGE)) / 100;
};

/** A delivery count -- impressions, views, clicks -- to the nearest whole number, half up. */
export const roundCount = (value: number): number => {
  if (!Number.isFinite(value)) return 0;
  return Math.sign(value) * Math.round(Math.abs(value) + HALF_NUDGE);
};
